
export class TrackingHistories {
  inaHistory: TrackingHistory[];
}
export class TrackingHistory {
  Id: number
  ChangedBy: string
  ChangedField: string
  ChangedDate: string
  ChangedValue: string
  ChangedFormId: number
}
